import { type CompareState, toggleCompareId } from "@/components/review/review-parts"
import { useTranslation } from "@/hooks/use-translation"
import { cn } from "@/lib/utils"

/**
 * Выбор карточки версии для сравнения (вкладки версий шота): пока идёт сравнение, перекрывает превью — клик
 * выбирает или снимает версию вместо просмотра. Выбранная — в рамке, в углу её номер в паре (1, 2).
 */
export function VersionCompareSlot({
  compare,
  id,
  onCompareChange,
}: {
  compare: CompareState
  id: number
  onCompareChange: (next: CompareState) => void
}) {
  const { t } = useTranslation("projects")
  if (!compare) return null
  const index = compare.ids.indexOf(id)
  const picked = index !== -1
  return (
    <button
      type="button"
      aria-pressed={picked}
      aria-label={t("review.compare.pick")}
      onClick={(e) => {
        e.stopPropagation()
        onCompareChange(toggleCompareId(compare, id))
      }}
      onDoubleClick={(e) => e.stopPropagation()}
      className={cn(
        "absolute inset-0 z-[5] cursor-pointer bg-transparent hover:bg-black/15",
        picked && "ring-2 ring-ui-accent ring-inset",
      )}
    >
      <span
        className={cn(
          "absolute top-1.5 right-1.5 flex h-5 w-5 items-center justify-center rounded-full text-[10.5px] font-semibold",
          picked ? "bg-ui-accent text-ui-on-accent" : "border-[1.5px] border-white/80 bg-black/55",
        )}
      >
        {picked ? index + 1 : ""}
      </span>
    </button>
  )
}
